import { NativeAppState } from 'native/state/store.native';
import { AnimalType, DistriwinFeedUnitType, IGeneralSettings } from 'shared/api/api';
import { StoreContainer } from 'shared/state/store-container';
import { SharedAppState } from 'shared/state/store.shared';
import { WebAppState } from 'web/state/store.web';

export const getFeedUnitType = (state: SharedAppState | NativeAppState | WebAppState) => {
	const generalSettings = state.generalSettings;
	if (generalSettings && generalSettings.entity && generalSettings.entity.distriwinFeedUnitType) {
		return generalSettings.entity.distriwinFeedUnitType;
	}
	return DistriwinFeedUnitType.FEsoFEsv;
};

export const getFeedUnitTypeFromStore = () => {
	return getFeedUnitType(StoreContainer.getState());
};

export const getFuOrKg = (animalType: AnimalType, generalSettings?: IGeneralSettings) => {
	let settings = generalSettings ?? StoreContainer.getState().generalSettings.entity;

	if (animalType === AnimalType.Finisher) {
		return settings.showFuOrKgFinisher;
	}
	else if (animalType === AnimalType.Weaner) {
		return settings.showFuOrKgWeaner;
	}
	return settings.showFuOrKgSow;
};


export const selectFeedingUnitType = (state: WebAppState) =>
	state.generalSettings && state.generalSettings.entity && state.generalSettings.entity.distriwinFeedUnitType
		? state.generalSettings.entity.distriwinFeedUnitType
		: DistriwinFeedUnitType.FEsoFEsv;
